import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '@et/environment';

@Injectable()
export class VersionNumberInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const version = localStorage.getItem('ET_VERSION');
    // Better Auth's CORS config doesn't allow this header, and version telemetry
    // is meant for our own resource-server APIs, not the identity provider — the
    // `escrowtab.com` substring check below would otherwise also match
    // `auth.escrowtab.com` and break the OIDC discovery/token requests with a
    // "header disallowed by preflight response" CORS error.
    const isBetterAuthRequest = request.url.startsWith(
      environment.betterAuth.baseUrl,
    );
    if (
      version &&
      !isBetterAuthRequest &&
      request.url.includes('escrowtab.com')
    ) {
      request = request.clone({
        setHeaders: {
          'ET-Version': version,
        },
      });
    }
    return next.handle(request);
  }
}
